import { useState, type ReactNode } from 'react';
import { FondoCordillera } from '../marca/FondoCordillera';
import { GuiaCumbre, useDialogo, type Animo, type Gesto } from '../marca/GuiaCumbre';
import type { Reaccion, Tramo } from '../../../lib/onboardingMarca/dialogo';

function pideMenosMovimiento(): boolean {
  try {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  } catch {
    return false;
  }
}

/**
 * Una pantalla del cuestionario corto con la forma de las del onboarding de marca
 * (ADR-2026-10-31-el-cuestionario-corto-con-el-diseno-del-de-marca): el fondo de cordillera,
 * Cumbre que habla arriba y, cuando termina, lo que hay que hacer y la barra de abajo.
 */
export function PantallaConCumbre({
  tramos,
  reaccion = null,
  animo = 'escucha',
  gesto = null,
  children,
  barra,
}: {
  /** Memorizados: si cambian, Cumbre vuelve a empezar. */
  tramos: Tramo[];
  reaccion?: Reaccion | null;
  animo?: Animo;
  gesto?: Gesto | null;
  /** Lo de la pantalla. Entra cuando Cumbre terminó de hablar. */
  children?: ReactNode;
  /** El botón para avanzar, pegado abajo. Entra con el resto. */
  barra?: ReactNode;
}) {
  const [quieto] = useState(pideMenosMovimiento);
  // Espera a que Cumbre llegue, como en el onboarding de marca.
  const dialogo = useDialogo(tramos, { instantaneo: quieto, arrancarEn: 900 });

  return (
    <div className="relative isolate flex min-h-[calc(100dvh-var(--om-barra))] flex-col">
      <FondoCordillera quieto={quieto} />

      <div className="mx-auto flex w-full max-w-[640px] flex-col gap-5 px-4 pb-10 pt-6 md:gap-6 md:pt-8">
        <GuiaCumbre
          tramos={tramos}
          letras={dialogo.letras}
          hablando={dialogo.hablando}
          terminado={dialogo.terminado}
          onCompletar={dialogo.completar}
          reaccion={reaccion}
          animo={animo}
          gesto={gesto}
          instantaneo={quieto}
        />
        {dialogo.terminado && children && <div className={`flex flex-col gap-5 ${quieto ? '' : 'om-aparece'}`}>{children}</div>}
      </div>

      {dialogo.terminado && barra && (
        <div className={`om-barra ${quieto ? '' : 'om-aparece-solo'}`}>
          <div className="om-barra__dentro">{barra}</div>
        </div>
      )}
    </div>
  );
}

export default PantallaConCumbre;
